import axios from 'axios'

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

// The login lives in an HttpOnly cookie the API sets: no script (and so no injected script) can read it.
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
})

// Handle errors
api.interceptors.response.use(
  response => response,
  error => {
    // A 401 from the login or sign-up form is a wrong password, not an expired session.
    const url = error.config?.url || ''
    const credentialCheck = url.includes('/api/auth/login') || url.includes('/api/auth/signup')
    if (error.response?.status === 401 && !credentialCheck) {
      localStorage.removeItem('user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
